import React, {Component} from 'react';
import {Row, Col, Card, CardHeader, CardBody, Input, FormGroup, Label, Form, FormText, Button} from 'reactstrap';

function ChangePassword() {
    return (
        <div className="animated fadeIn">
            <Card>
              <CardHeader>My Profile</CardHeader>
              <CardBody>
                <Form action="" method="post" className="form-horizontal">
                  <FormGroup row>
                  <Col md="6">
                      <FormGroup row className="mb-3 pb-2">
                        <Col md="3">
                            <Label htmlFor="hf-password">Old Password</Label>
                        </Col>
                        <Col xs="12" md="9">
                            <Input type="password" id="hf-password" name="hf-password" placeholder="Old password"/>
                        </Col>
                      </FormGroup>
                      <FormGroup row className="mb-3 pb-2">
                        <Col md="3">
                            <Label htmlFor="hf-Npassword">New Password</Label>
                        </Col>
                        <Col xs="12" md="9">
                            <Input type="password" id="hf-Npassword" name="hf-Npassword" placeholder="New password" />
                        </Col>
                      </FormGroup>

                      <FormGroup row className="mb-3 pb-2">
                        <Col md="3">
                            <Label htmlFor="hf-Npassword">Confirm Password</Label>
                        </Col>
                        <Col xs="12" md="9">
                            <Input type="password" id="confirm-Npassword" name="confirm-Npassword" placeholder="Confirm password" />
                        </Col>
                      </FormGroup>
                      <FormGroup row className="mb-3 pb-2">
                        <Col xs="12" md="9" className="offset-3">
                            <Button color="black" className="px-4">Submit</Button>
                        </Col>
                      </FormGroup>
                  </Col>
                  </FormGroup>
                </Form>
              </CardBody>
            </Card>
        </div>
    )
}
export default ChangePassword;
